import React from 'react';
import { CircularProgress } from '@mui/material';
import styles from './scss/landingPageSpinner.module.scss';

function LandingPageSpinner() {
  return (
    <div className={`container-fluid ${styles.LandingPage}`}>
      <CircularProgress />
    </div>
  );
}

export default LandingPageSpinner;
